export const translations = {
  es: {
    // Header
    'booking.title': 'Reserva de Bicicletas',
    'booking.subtitle': 'Completa los pasos para realizar tu reserva',
    'header.top.phoneMessage': '¿Más de un día? Haz tu reserva por teléfono',
    'header.top.phone': '+34 622 79 97 96',
    'header.menu.home': 'Inicio',
    'header.menu.rental': 'Alquiler',
    'header.menu.tours': 'Tours',
    'header.menu.delivery': 'Entrega en hoteles',
    'header.menu.accessories': 'Accesorios',
    'header.menu.contact': 'Contacto',
    'header.aria.menu': 'Menú principal',
    'header.aria.openMenu': 'Abrir menú',
    'header.aria.closeMenu': 'Cerrar menú',
    'header.lang.es': 'Español',
    'header.lang.en': 'English',
    'header.lang.de': 'Deutsch',
    
    // Stepper
    'stepper.step1': 'Fechas',
    'stepper.step2': 'Bicicletas',
    'stepper.step3': 'Accesorios',
    'stepper.step4': 'Entrega',
    'stepper.step5': 'Cliente',
    'stepper.step6': 'Pago',
    'stepper.back': 'Atrás',
    'stepper.step': 'Paso',
    'stepper.of': 'de',
    
    // Date Selection
    'date.title': 'Selecciona las fechas de tu reserva',
    'date.start.label': 'Fecha y hora de inicio',
    'date.end.label': 'Fecha y hora de fin',
    'date.start.help': 'Selecciona una fecha y hora entre las 9:00 y las 21:00',
    'date.end.help': 'Mínimo 1 día, sin límite máximo',
    'date.info.title': 'Información importante',
    'date.info.min': '• La duración mínima de la reserva es de 1 día completo (24 horas)',
    'date.info.max': '• Sin límite máximo de duración',
    'date.info.hours': '• El horario de servicio es de 9:00 a 21:00 horas',
    'date.info.advance': '• Las reservas se pueden hacer con un mínimo de 24 horas de antelación',
    'date.duration': 'Duración de la reserva:',
    'date.total': 'Total:',
    'date.hours': 'horas',
    'date.day': 'día',
    'date.days': 'días',
    'date.hour': 'hora',
    'date.and': 'y',
    'date.over.limit': 'Reserva extendida',
    'date.over.contact': 'Para reservas más largas, contacta con',
    'date.error.min': 'La duración mínima de la reserva debe ser de 1 día completo (24 horas)',
    'date.error.max': 'No hay límite máximo de duración para las reservas',
    'date.error.start.time': 'La hora de inicio debe estar entre las 9:00 y las 21:00',
    'date.error.end.time': 'La hora de fin debe estar entre las 9:00 y las 21:00',
    'date.error.start.past': 'La fecha de inicio no puede ser anterior a hoy',
    'date.error.required': 'Selecciona una fecha de recogida y una de devolución',
    'date.error.min.days': 'La reserva debe ser de al menos 1 día',
    'date.error.closed': 'Estamos cerrados ese día: la recogida y la devolución no pueden ser en un día cerrado',
    'date.continue': 'Continuar',
    'date.schedule.info.title': 'Información de Horarios',
    'date.schedule.info.pickup': '• Horario de recogida: 9:00 AM',
    'date.schedule.info.return': '• Horario de devolución: 21:00 PM (9:00 PM)',
    'date.schedule.info.minimum': '• Reserva mínima: 1 día completo',
    'date.schedule.info.maximum': '• Sin límite máximo de días',
    'date.schedule.info.advance': '• Reserva con al menos 24 horas de antelación',
    'date.schedule.title': 'Horarios',
    'date.schedule.mobile.times': 'Recogida: 9:00 AM • Devolución: 21:00 PM',
    'date.schedule.mobile.duration': 'Mínimo: 1 día • Sin límite máximo',
    'date.pickup.label': 'Fecha de recogida',
    'date.pickup.help': 'Selecciona la fecha de recogida (9:00 AM)',
    'date.return.label': 'Fecha de devolución',
    'date.return.help': 'Selecciona la fecha de devolución (21:00 PM)',
    'date.duration.label': 'Duración de la reserva:',
    'date.duration.range': 'Desde {start} a {end}',
    
    // Date Range Picker
    'daterangepicker.select.range': 'Seleccionar rango de fechas',
    'daterangepicker.clear.dates': 'Limpiar fechas',
    'daterangepicker.select.dates': 'Seleccionar fechas',
    'daterangepicker.close': 'Cerrar',
    'daterangepicker.closed.legend': 'Días cerrados (sin recogida ni devolución)',
    'daterangepicker.start.date': 'Fecha inicio',
    'daterangepicker.end.date': 'Fecha fin',
    'daterangepicker.duration': 'Duración:',
    'daterangepicker.confirm': 'Seleccionar fechas',

    // Bike Catalog
    'bike.title': 'Selecciona las bicicletas',
    'bike.filters': 'Filtros',
    'bike.category': 'Categoría',
    'bike.size': 'Tamaño',
    'bike.all.categories': 'Todas las categorías',
    'bike.all.sizes': 'Todos los tamaños',
    'bike.base.price': '€/hora',
    'bike.select.sizes': 'Selecciona las tallas:',
    'bike.available': 'disponibles',
    'bike.loading': 'Cargando disponibilidad...',
    'bike.error': 'Error al verificar la disponibilidad:',
    'bike.no.models': 'No hay bicicletas disponibles con los filtros seleccionados',
    'bike.filter.all.categories': 'Todas las categorías',
    'bike.filter.all.sizes': 'Todas las tallas',
    'bike.filter.category': 'Selecciona una categoría',
    'bike.filter.size': 'Selecciona un tamaño',
    'bike.dates.label': 'Fechas de reserva',
    'bike.dates.required.prompt': 'Añade un periodo de fechas para buscar disponibilidad.',
    'bike.selected.singular': 'seleccionada',
    'bike.selected.plural': 'seleccionadas',
    'bike.mixed.seasons': 'Temporadas mixtas',
    'bike.back.to.info': 'Volver a la información de la bicicleta',
    'bike.total.availability': 'Disponibilidad total:',
    'bike.bikes': 'bicicletas',
    'bike.price.from': 'Desde',
    'bike.image.none': 'Sin imagen',
    'bike.image.loading': 'Cargando imagen…',
    'bike.image.error': 'No se pudo cargar la imagen',
    'bike.no.availability': 'Algunas bicicletas seleccionadas ya no están disponibles para estas fechas y se han eliminado.',
    'bike.more': 'más',
    'bike.and': 'y',
    
    // Accessory Selection
    'accessory.title': 'Selecciona los accesorios',
    'accessory.loading': 'Cargando accesorios...',
    'accessory.selected.bikes': 'Bicicletas seleccionadas',
    'accessory.for.bike': 'Accesorios y seguros para',
    'accessory.summary': 'Resumen de precios',
    'accessory.bikes.total': 'Total bicicletas',
    'accessory.accessories.total': 'Total accesorios',
    'accessory.grand.total': 'Total general',
    'accessory.price.fixed': 'Precio fijo',
    'accessory.price.daily': 'Precio por día',
    'accessory.price.total': 'total',
    
    // Price Breakdown
    'price.title': 'Resumen de la reserva',
    'price.select.bikes': 'Selecciona bicicletas para ver el desglose',
    'price.selected.dates': 'Fechas seleccionadas:',
    'price.duration': 'Duración:',
    'price.selected.bikes': 'Bicicletas seleccionadas:',
    'price.size': 'Talla',
    'price.number': 'Nº',
    'price.total': 'total',
    'price.per.hour': 'Precio por hora',
    'price.total.duration': 'Duración total',
    'price.grand.total': 'Total',
    'price.vat.included': 'IVA incluido',
    'price.base': 'Base',
    'price.vat': 'IVA (21%)',
    'price.bikes': 'Bicicletas',
    'price.discount.3to5.info': 'Reservas de 3 a 5 días: se aplica un {percent}% de descuento sobre el alquiler de bicicletas (no incluye accesorios, seguros ni entrega). El importe indicado ya refleja esta tarifa.',
    'price.discount.3to5.info.mixed': 'Reservas de 3 a 5 días: el descuento sobre el alquiler de bicicletas depende de cada modelo (véase el detalle arriba). No afecta a accesorios, seguros ni entrega.',
    'price.discount.3to5.info.generic': 'Tarifa por estancias de 3 a 5 días aplicada al alquiler de bicicletas (el subtotal ya la incluye). No afecta a accesorios, seguros ni entrega.',
    'price.accessories': 'Accesorios',
    'price.accessories.selected': 'Accesorios y seguros seleccionados:',
    'price.accessory.fixed': 'fijo',
    'price.accessory.per.day': 'día',
    'price.delivery.home': 'Entrega a domicilio',
    'price.warning.insurance.none': 'No has seleccionado ningún seguro para esta reserva.',
    'price.warning.insurance.only.one.bike': 'El seguro solo se ha seleccionado para una bicicleta.',
    'price.warning.insurance.partial': 'El seguro solo se ha seleccionado para {count} bicicletas.',

    // Payment
    'payment.title': 'Pago Seguro',
    'payment.subtitle': 'Completa tu información de pago para finalizar la reserva',
    'payment.secure': 'Pago 100% seguro con Stripe',
    'payment.card.info': 'Información de la tarjeta',
    'payment.processing': 'Procesando...',
    'payment.pay': 'Pagar',
    'payment.plan.title': 'Forma de pago',
    'payment.plan.full': 'Pagar el total ahora',
    'payment.plan.partial': 'Pagar solo el anticipo',
    'payment.plan.partial.note': 'Anticipo aproximado del {percent}% sobre el total: {amount}. El resto lo gestionaremos contigo más adelante.',
    'payment.info.title': 'Información de Pago',
    'payment.summary.title': 'Resumen de la Reserva',
    'payment.summary.customer.data': 'Datos del Cliente',
    'payment.summary.price.breakdown': 'Desglose de Precios',
    'payment.summary.duration': 'Duración de la reserva',
    'payment.summary.bikes': 'Bicicletas',
    'payment.summary.accessories.total': 'Total accesorios',
    'payment.summary.insurance.total': 'Seguros',
    'payment.summary.delivery.total': 'Total de la entrega',
    'payment.summary.booking.total': 'Total de la reserva',
    'payment.summary.vehicles.selected': 'Vehículos Seleccionados',
    'payment.summary.size': 'Talla',
    'payment.summary.accessories.selected': 'Accesorios Seleccionados',
    'payment.summary.daily': 'Diario',
    'payment.summary.fixed': 'Fijo',
    'payment.summary.vehicle.accessoriesOnly': 'Accesorios',
    'payment.summary.vehicle.insuranceOnly': 'Seguros',
    'payment.summary.vehicle.noExtras': 'Sin accesorios ni seguros para este vehículo.',
    'payment.summary.vehicle.bikeRental': 'Alquiler de la bicicleta',
    'payment.summary.vehicle.subtotalVehicle': 'Total este vehículo',
    'payment.error.create': 'Error al crear el pago',
    'payment.error.confirm': 'Error al confirmar el pago',
    'payment.error.incomplete': 'El pago no se pudo completar',
    'payment.error.cancellation.policy.required': 'Debes aceptar los términos y condiciones de compra para continuar',
    'payment.cancellation.policy.accept': 'Acepto los',
    'payment.cancellation.policy.link': 'términos y condiciones de compra',
    'payment.cancellation.policy.url': 'https://bikerentmallorca.com/terminos-y-condiciones-de-compra/',
    'payment.confirmation.title': '¡Reserva Confirmada!',
    'payment.confirmation.step.completed': 'Paso 6 de 6 - Completado',
    'payment.confirmation.success.title': '¡Pago Exitoso!',
    'payment.confirmation.success.message': 'Tu reserva ha sido confirmada y procesada correctamente',
    'payment.confirmation.booking.details': 'Detalles de la Reserva',
    'payment.confirmation.booking.number': 'Número de reserva:',
    'payment.confirmation.booking.customer': 'Cliente:',
    'payment.confirmation.booking.total.paid': 'Importe pagado ahora:',
    'payment.confirmation.booking.total.reservation': 'Total de la reserva',
    'payment.confirmation.balance.pending': 'Importe pendiente',
    'payment.confirmation.balance.pending.note': 'Deberás abonar este importe antes del inicio del alquiler (recogida de las bicicletas).',
    'payment.confirmation.email.error': 'No se ha podido enviar el correo de confirmación. Si no lo recibes, contáctanos.',
    'payment.confirmation.next.steps.title': 'Próximos pasos',
    'payment.confirmation.next.steps.email': 'Recibirás un email de confirmación en breve',
    'payment.confirmation.next.steps.dni': 'Presenta tu documento de identificación en la recogida de la bicicleta',
    'payment.confirmation.next.steps.arrive': 'Llega 10 minutos antes de tu hora de recogida',
    'payment.confirmation.next.steps.contact': 'Contacta con nosotros si tienes alguna duda',
    'payment.confirmation.goHome': 'Ir a inicio',
    'payment.confirmation.thank.you': '¡Gracias por confiar en nosotros!',
    'payment.confirmation.enjoy': 'Te esperamos para disfrutar de una experiencia única',
    'booking.dates.label': 'Fechas de alquiler',
    'booking.dates.until': 'hasta',
    
    // Delivery Options
    'delivery.title': 'Opciones de Entrega/Recogida',
    'delivery.subtitle': 'Elige cómo prefieres recibir tu bicicleta',
    'delivery.pickup.title': 'Recogida en tienda',
    'delivery.pickup.description': 'Recoge tu bicicleta directamente en nuestra tienda',
    'delivery.pickup.benefit.no.cost': 'Sin coste adicional',
    'delivery.pickup.benefit.immediate': 'Disponible inmediatamente',
    'delivery.pickup.benefit.assistance': 'Asistencia personalizada',
    'delivery.pickup.benefit.review': 'Revisión técnica incluida',
    'delivery.delivery.title': 'Entrega a domicilio',
    'delivery.delivery.title.from.price': 'Entrega a domicilio desde 40€',
    'delivery.delivery.description': 'Te llevamos la bicicleta a tu casa u hotel',
    'delivery.delivery.benefit.location': 'Entrega en tu ubicación',
    'delivery.delivery.benefit.flexible': 'Horario flexible',
    'delivery.delivery.benefit.assembly': 'Montaje incluido',
    'delivery.delivery.benefit.pickup': 'Recogida al finalizar',
    'delivery.delivery.benefit.fixed.cost': 'Coste fijo de 40€ para reservas ≤ 3 días',
    'delivery.cost.calculated': 'Coste de entrega calculado',
    'delivery.cost.based.on.distance': 'Basado en la distancia desde nuestra tienda',
    'delivery.info.title': 'Información sobre el servicio de entrega',
    'delivery.info.base.cost': 'El servicio tiene un coste desde 40 €, que incluye hasta 15 km desde nuestro local en Cala Millor.',
    'delivery.info.mallorca.only': 'Las entregas y recogidas solo se realizan dentro de la isla de Mallorca.',
    'delivery.info.supplement': 'Si la dirección de entrega se encuentra a más de 15 km, se aplicará un suplemento de 2,50 € por kilómetro adicional.',
    'delivery.info.distance.calculation': 'Los kilómetros se calculan únicamente según la distancia de un trayecto (de nuestro local hasta tu ubicación).',
    'delivery.info.example': 'Ejemplo:',
    'delivery.info.example.text': 'Si tu hotel está a 20 km, se aplican 5 km extra → 5 × 2,50 € = 12,50 € de suplemento.',
    'delivery.info.transparent': 'Esto asegura un servicio transparente, justo y adaptado a la distancia real de tu ubicación.',
    'delivery.address.title': 'Dirección de entrega',
    'delivery.address.full': 'Dirección completa',
    'delivery.address.placeholder': 'La dirección se completará automáticamente desde el mapa, o puedes escribirla manualmente aquí...',
    'delivery.address.help': 'Puedes añadir detalles adicionales como número de piso, código de acceso, o instrucciones especiales',
    'delivery.map.title': 'Ubicación en el mapa',
    'delivery.map.search.placeholder': 'Busca tu dirección o haz clic en el mapa...',
    'delivery.map.search': 'Buscar',
    'delivery.map.searching': 'Buscando...',
    'delivery.map.location.valid': '✔️ Ubicación válida dentro de Mallorca',
    'delivery.map.location.invalid': '❌ La ubicación NO está dentro de Mallorca.',
    'delivery.map.address.not.found': '❌ No se encontró la dirección.',
    'delivery.map.address.error': '❌ Error al buscar la dirección. Por favor, intenta de nuevo.',
    'delivery.map.distance.to.store': 'Distancia a la tienda:',
    'delivery.map.address.label': 'Dirección:',
    'delivery.map.base.cost': 'Coste base:',
    'delivery.map.base.cost.includes': '40,00 € (incluye hasta {km} km)',
    'delivery.map.supplement': 'Suplemento por {km} km adicionales:',
    'delivery.map.total.delivery': 'Total entrega:',
    'delivery.map.address.selected': 'Dirección seleccionada',
    'delivery.map.address.correct': 'Si la dirección mostrada no es correcta, puedes hacer clic directamente en el mapa para seleccionar la ubicación exacta.',
    'delivery.map.help': 'Puedes buscar una dirección o hacer clic directamente en el mapa para seleccionar tu ubicación',
    'delivery.map.our.store': 'Nuestra tienda',
    'delivery.map.store.location': 'Cala Millor, Mallorca',
    'delivery.map.your.location': 'Tu ubicación',
    'delivery.map.location.selected': 'Ubicación seleccionada',
    'delivery.map.distance': 'Distancia',
    
    // Common
    // Customer Info
    'customer.title': 'Datos del Cliente',
    'customer.subtitle': 'Completa tus datos personales para continuar con la reserva',
    'customer.name.label': 'Nombre completo',
    'customer.name.placeholder': 'Ingresa tu nombre completo',
    'customer.name.required': 'El nombre es requerido',
    'customer.name.min.length': 'El nombre debe tener al menos 2 caracteres',
    'customer.name.max.length': 'El nombre no puede superar 100 caracteres',
    'customer.name.invalid': 'Solo se permiten letras y espacios (sin números ni caracteres especiales)',
    'customer.email.label': 'Email',
    'customer.email.placeholder': 'tu@email.com',
    'customer.email.required': 'El email es requerido',
    'customer.email.invalid': 'Introduce un correo electrónico válido',
    'customer.email.max.length': 'El email no puede superar 254 caracteres',
    'customer.phone.label': 'Teléfono',
    'customer.phone.placeholder': '123456789',
    'customer.phone.required': 'El teléfono es requerido',
    'customer.phone.invalid': 'Teléfono inválido (9 dígitos)',
    'customer.phone.prefix.label': 'Prefijo',
    'customer.phone.prefix.hint': 'Hasta 4 dígitos, con o sin +',
    'customer.phone.prefix.placeholder': '+34',
    'customer.phone.prefix.required': 'El prefijo telefónico es requerido',
    'customer.phone.prefix.invalid': 'Prefijo inválido (hasta 4 dígitos, con o sin +)',
    'customer.dni.label': 'Documento de identificación',
    'customer.dni.placeholder': 'DNI, NIE o pasaporte',
    'customer.dni.required': 'El documento de identificación es obligatorio',
    'customer.dni.invalid': 'Formato no válido (DNI: 8 dígitos + letra, NIE: X/Y/Z + 7 dígitos + letra, pasaporte: alfanumérico 5-20 caracteres)',
    'customer.address.label': 'Dirección (facturación)',
    'customer.address.placeholder': 'Calle, número, código postal, localidad',
    'customer.address.required': 'La dirección es obligatoria para reservas de 3000 € o más',
    'customer.info.title': 'Información importante',
    'customer.info.protected': 'Tus datos están protegidos y solo se usan para la reserva',
    'customer.info.dni.required': 'Necesitaremos tu documento de identificación para la recogida de la bicicleta',
    'customer.info.email.confirmation': 'Te enviaremos confirmación por email',
    'customer.info.contact': 'Puedes contactarnos por teléfono si tienes dudas',
    'customer.processing': 'Procesando...',
    'customer.clear.temp.booking': 'Limpiar reserva temporal',
    'customer.reload.page': 'Recargar página',
    'customer.error.update.temp': 'Error al actualizar la reserva temporal',
    'customer.error.create.temp': 'Error al crear la reserva temporal',
    'customer.error.handle.temp': 'Error al manejar la reserva temporal',
    'customer.error.no.vehicles': 'No hay vehículos seleccionados',
    'customer.error.no.dates': 'No hay fechas seleccionadas',
    'customer.error.vehicles.unavailable.help': 'Por favor, selecciona otros vehículos o contacta con soporte.',

    // Inseam (opcional por modelo)
    'inseam.title': 'Medida de entrepierna (opcional)',
    'inseam.subtitle': 'Algunos modelos permiten indicar esta medida para ajustar mejor la bicicleta.',
    'inseam.label': 'Entrepierna (cm)',
    'inseam.placeholder': 'Ej. 82',
    'inseam.error.invalid': 'Medida de entrepierna inválida. Debe estar entre 30 y 120 cm.',
    'inseam.step2.hint': 'Algunas bicicletas seleccionadas permiten indicar la medida de entrepierna en el paso 5 (Cliente).',
    'inseam.help.aria': '¿Qué es la medida de entrepierna?',
    'inseam.help.caption': 'Mide desde la entrepierna hasta el suelo (en cm), con calzado similar al que usarás para montar.',
    
    // Common
    'common.continue': 'Continuar',
    'common.back': 'Atrás',
    'common.loading': 'Cargando...',
    'common.error': 'Error',
    'common.success': 'Éxito',
    'common.warning': 'Advertencia',
    'common.info': 'Información',
    'common.connection.error': 'Error de conexión.',
    
    // Language Selector
    'language.selector': 'Idioma',
    'language.spanish': 'Español',
    'language.english': 'English',
    'language.german': 'Deutsch',
    
    // Payment
    'payment.summary': 'Resumen de la Reserva',
    'payment.bike': 'Bicicleta',
    'payment.bikes': 'Bicicletas',
    'payment.accessories': 'Accesorios',
    'payment.duration': 'Duración',
    'payment.days': 'días',
    'payment.price': 'Precio',
    'payment.total': 'Total',
    'payment.info.description': 'Introduce los datos de tu tarjeta de crédito o débito para completar la reserva.',
    'payment.test.title': 'Datos de Prueba',
    'payment.test.card': 'Tarjeta',
    'payment.test.expiry': 'Vencimiento',
    'payment.test.cvv': 'CVV',
    'payment.card.number': 'Número de Tarjeta',
    'payment.card.expiry': 'Fecha de Vencimiento',
    'payment.card.cvv': 'CVV',
    'payment.loading': 'Cargando información de pago...',
    'payment.error.title': 'Error en el Pago',
    'payment.error.retry': 'Reintentar',
    'payment.success.title': '¡Pago Exitoso!',
    'payment.success.message': 'Tu reserva ha sido confirmada y el pago procesado correctamente.',
    'payment.success.booking': 'Número de Reserva',
    'payment.vat.included': 'IVA incluido',

    // Footer
    'footer.title.contact': 'Contacto',
    'footer.title.company': 'Empresa',
    'footer.title.quickLinks': 'Enlaces rápidos',
    'footer.title.about': 'Sobre la tienda',
    'footer.title.schedule': 'Horario',
    'footer.contact.phone1': '+34 971 58 58 38',
    'footer.contact.phone2': '+34 622 79 97 96',
    'footer.contact.email': 'info@monkeyjetski.com',
    'footer.contact.address': 'Carrer Arenal, 6, 07560 Cala Millor, Illes Balears',
    'footer.company.bikes': 'Bicicletas',
    'footer.company.jetski': 'Tours jetski',
    'footer.company.buggy': 'Tours Buggy',
    'footer.company.parasailing': 'Parasailing',
    'footer.company.workshop': 'Taller Bicicletas',
    'footer.quick.rental': 'Alquiler Bicicleta',
    'footer.quick.tours': 'Tours bicicleta',
    'footer.quick.hotels': 'Entrega en hoteles',
    'footer.quick.extras': 'Extras y Accesorios',
    'footer.quick.routes': 'Rutas bicicleta',
    'footer.about.contact': 'Contacto',
    'footer.about.us': 'Sobre nosotros',
    'footer.about.gallery': 'Galeria',
    'footer.about.legal': 'Aviso legal',
    'footer.about.cookies': 'Cookies',
    'footer.schedule.weekdays': 'Lun - Vie',
    'footer.schedule.saturday': 'Sábado',
    'footer.schedule.sunday': 'Domingo',
    'footer.schedule.hours': '09:00 - 22:00',
    'footer.copyright': 'Copyright © {year} All Right Reserved MonkeyOnTours',
    'footer.social.strava': 'Strava',
    'footer.social.instagram': 'Instagram',
    'footer.social.facebook': 'Facebook',
    'footer.social.youtube': 'YouTube',

    // Maintenance
    'maintenance.message': 'En estos momentos estamos en mantenimiento, volveremos pronto.',
    'maintenance.contact.title': 'Puedes contactarnos en:',

    // Soporte ante error de API (5xx)
    'support.api.banner.message':
      'Ha ocurrido un problema técnico con nuestros servidores. Si persiste, reserva por teléfono o escríbenos:',
    'support.api.banner.dismiss': 'Cerrar aviso',
  },

  en: {
    // Header
    'booking.title': 'Bike Rental Booking',
    'booking.subtitle': 'Complete the steps to make your reservation',
    'header.top.phoneMessage': 'More than one day? Book by phone',
    'header.top.phone': '+34 622 79 97 96',
    'header.menu.home': 'Home',
    'header.menu.rental': 'Rental',
    'header.menu.tours': 'Tours',
    'header.menu.delivery': 'Hotel delivery',
    'header.menu.accessories': 'Accessories',
    'header.menu.contact': 'Contact',
    'header.aria.menu': 'Main menu',
    'header.aria.openMenu': 'Open menu',
    'header.aria.closeMenu': 'Close menu',
    'header.lang.es': 'Español',
    'header.lang.en': 'English',
    'header.lang.de': 'Deutsch',
    
    // Stepper
    'stepper.step1': 'Dates',
    'stepper.step2': 'Bikes',
    'stepper.step3': 'Accessories',
    'stepper.step4': 'Delivery',
    'stepper.step5': 'Customer',
    'stepper.step6': 'Payment',
    'stepper.back': 'Back',
    'stepper.step': 'Step',
    'stepper.of': 'of',
    
    // Date Selection
    'date.title': 'Select your reservation dates',
    'date.start.label': 'Start date and time',
    'date.end.label': 'End date and time',
    'date.start.help': 'Select a date and time between 9:00 AM and 9:00 PM',
    'date.end.help': 'Minimum 1 day, no maximum limit',
    'date.info.title': 'Important information',
    'date.info.min': '• Minimum reservation duration is 1 complete day (24 hours)',
    'date.info.max': '• No maximum duration limit',
    'date.info.hours': '• Service hours are from 9:00 AM to 9:00 PM',
    'date.info.advance': '• Reservations can be made with a minimum of 24 hours notice',
    'date.duration': 'Reservation duration:',
    'date.total': 'Total:',
    'date.hours': 'hours',
    'date.day': 'day',
    'date.days': 'days',
    'date.hour': 'hour',
    'date.and': 'and',
    'date.over.limit': 'Extended reservation',
    'date.over.contact': 'For longer reservations, contact',
    'date.error.min': 'Minimum reservation duration must be 1 complete day (24 hours)',
    'date.error.max': 'No maximum duration limit for reservations',
    'date.error.start.time': 'Start time must be between 9:00 AM and 9:00 PM',
    'date.error.end.time': 'End time must be between 9:00 AM and 9:00 PM',
    'date.error.start.past': 'Start date cannot be before today',
    'date.error.required': 'Select a pickup date and a return date',
    'date.error.min.days': 'Reservation must be at least 1 day',
    'date.error.closed': 'We are closed on that day: pickup and return cannot be on a closed day',
    'date.continue': 'Continue',
    'date.schedule.info.title': 'Schedule Information',
    'date.schedule.info.pickup': '• Pickup time: 9:00 AM',
    'date.schedule.info.return': '• Return time: 9:00 PM',
    'date.schedule.info.minimum': '• Minimum reservation: 1 complete day',
    'date.schedule.info.maximum': '• No maximum day limit',
    'date.schedule.info.advance': '• Reservations with at least 24 hours notice',
    'date.schedule.title': 'Schedule',
    'date.schedule.mobile.times': 'Pickup: 9:00 AM • Return: 9:00 PM',
    'date.schedule.mobile.duration': 'Minimum: 1 day • No maximum limit',
    'date.pickup.label': 'Pickup date',
    'date.pickup.help': 'Select pickup date (9:00 AM)',
    'date.return.label': 'Return date',
    'date.return.help': 'Select return date (9:00 PM)',
    'date.duration.label': 'Reservation duration:',
    'date.duration.range': 'From {start} to {end}',
    
    // Date Range Picker
    'daterangepicker.select.range': 'Select date range',
    'daterangepicker.clear.dates': 'Clear dates',
    'daterangepicker.select.dates': 'Select dates',
    'daterangepicker.close': 'Close',
    'daterangepicker.closed.legend': 'Closed days (no pickup or return)',
    'daterangepicker.start.date': 'Start date',
    'daterangepicker.end.date': 'End date',
    'daterangepicker.duration': 'Duration:',
    'daterangepicker.confirm': 'Select dates',
    
    // Bike Catalog
    'bike.title': 'Select bikes',
    'bike.filters': 'Filters',
    'bike.category': 'Category',
    'bike.size': 'Size',
    'bike.all.categories': 'All categories',
    'bike.all.sizes': 'All sizes',
    'bike.base.price': '€/hour',
    'bike.select.sizes': 'Select sizes:',
    'bike.available': 'available',
    'bike.loading': 'Loading availability...',
    'bike.error': 'Error checking availability:',
    'bike.no.models': 'No bikes available with the selected filters',
    'bike.filter.all.categories': 'All categories',
    'bike.filter.all.sizes': 'All sizes',
    'bike.filter.category': 'Category',
    'bike.filter.category.placeholder': 'Select a category',
    'bike.filter.size': 'Select a size',
    'bike.dates.label': 'Reservation dates',
    'bike.dates.required.prompt': 'Add a date range to check availability.',
    'bike.selected.singular': 'selected',
    'bike.selected.plural': 'selected',
    'bike.mixed.seasons': 'Mixed seasons',
    'bike.back.to.info': 'Back to bike information',
    'bike.total.availability': 'Total availability:',
    'bike.bikes': 'bikes',
    'bike.price.from': 'From',
    'bike.image.none': 'No image',
    'bike.image.loading': 'Loading image…',
    'bike.image.error': 'Could not load image',
    'bike.no.availability': 'Some selected bikes are no longer available for these dates and have been removed.',
    'bike.more': 'more',
    'bike.and': 'and',
    
    // Accessory Selection
    'accessory.title': 'Select accessories',
    'accessory.loading': 'Loading accessories...',
    'accessory.selected.bikes': 'Selected bikes',
    'accessory.for.bike': 'Accessories and insurance for',
    'accessory.summary': 'Price summary',
    'accessory.bikes.total': 'Bikes total',
    'accessory.accessories.total': 'Accessories total',
    'accessory.grand.total': 'Grand total',
    'accessory.price.fixed': 'Fixed price',
    'accessory.price.daily': 'Daily price',
    'accessory.price.total': 'total',
    
    // Price Breakdown
    'price.title': 'Reservation summary',
    'price.select.bikes': 'Select bikes to see breakdown',
    'price.selected.dates': 'Selected dates:',
    'price.duration': 'Duration:',
    'price.selected.bikes': 'Selected bikes:',
    'price.size': 'Size',
    'price.number': 'No.',
    'price.total': 'total',
    'price.per.hour': 'Price per hour',
    'price.total.duration': 'Total duration',
    'price.grand.total': 'Total',
    'price.vat.included': 'VAT included',
    'price.base': 'Base',
    'price.vat': 'VAT (21%)',
    'price.bikes': 'Bikes',
    'price.discount.3to5.info': '3–5 day bookings: a {percent}% discount applies to bike rental only (not accessories, insurance or delivery). The amount shown already includes this rate.',
    'price.discount.3to5.info.mixed': '3–5 day bookings: the bike rental discount varies by model (see details above). It does not apply to accessories, insurance or delivery.',
    'price.discount.3to5.info.generic': '3–5 day stay rate applied to bike rental (already included in the subtotal). Does not apply to accessories, insurance or delivery.',
    'price.accessories': 'Accessories',
    'price.accessories.selected': 'Selected accessories and insurance:',
    'price.accessory.fixed': 'fixed',
    'price.accessory.per.day': 'day',
    'price.delivery.home': 'Home delivery',
    'price.warning.insurance.none': 'You have not selected any insurance for this booking.',
    'price.warning.insurance.only.one.bike': 'Insurance has only been selected for one bike.',
    'price.warning.insurance.partial': 'Insurance has only been selected for {count} bikes.',

    // Payment
    'payment.title': 'Secure Payment',
    'payment.subtitle': 'Complete your payment information to finalize the reservation',
    'payment.secure': '100% secure payment with Stripe',
    'payment.card.info': 'Card information',
    'payment.processing': 'Processing...',
    'payment.pay': 'Pay',
    'payment.plan.title': 'Payment option',
    'payment.plan.full': 'Pay the full amount now',
    'payment.plan.partial': 'Pay a deposit only',
    'payment.plan.partial.note': 'Deposit of about {percent}% of the total: {amount}. We will arrange the balance with you later.',
    'payment.info.title': 'Payment Information',
    'payment.summary.title': 'Reservation Summary',
    'payment.summary.customer.data': 'Customer Data',
    'payment.summary.price.breakdown': 'Price Breakdown',
    'payment.summary.duration': 'Reservation duration',
    'payment.summary.bikes': 'Bikes',
    'payment.summary.accessories.total': 'Total accessories',
    'payment.summary.insurance.total': 'Insurance',
    'payment.summary.delivery.total': 'Total delivery',
    'payment.summary.booking.total': 'Total reservation',
    'payment.summary.vehicles.selected': 'Selected Vehicles',
    'payment.summary.size': 'Size',
    'payment.summary.accessories.selected': 'Selected Accessories',
    'payment.summary.daily': 'Daily',
    'payment.summary.fixed': 'Fixed',
    'payment.summary.vehicle.accessoriesOnly': 'Accessories',
    'payment.summary.vehicle.insuranceOnly': 'Insurance',
    'payment.summary.vehicle.noExtras': 'No accessories or insurance for this vehicle.',
    'payment.summary.vehicle.bikeRental': 'Bike rental',
    'payment.summary.vehicle.subtotalVehicle': 'Vehicle total',
    'payment.error.create': 'Error creating payment',
    'payment.error.confirm': 'Error confirming payment',
    'payment.error.incomplete': 'Payment could not be completed',
    'payment.error.cancellation.policy.required': 'You must accept the booking and rental terms and conditions to continue',
    'payment.cancellation.policy.accept': 'I accept the',
    'payment.cancellation.policy.link': 'booking and rental terms and conditions',
    'payment.cancellation.policy.url': 'https://bikerentmallorca.com/en/booking-and-rental-terms-and-conditions/',
    'payment.confirmation.title': 'Reservation Confirmed!',
    'payment.confirmation.step.completed': 'Step 6 of 6 - Completed',
    'payment.confirmation.success.title': 'Payment Successful!',
    'payment.confirmation.success.message': 'Your reservation has been confirmed and processed correctly',
    'payment.confirmation.booking.details': 'Reservation Details',
    'payment.confirmation.booking.number': 'Reservation number:',
    'payment.confirmation.booking.customer': 'Customer:',
    'payment.confirmation.booking.total.paid': 'Amount paid now:',
    'payment.confirmation.booking.total.reservation': 'Reservation total',
    'payment.confirmation.balance.pending': 'Outstanding balance',
    'payment.confirmation.balance.pending.note': 'You must pay this amount before the rental starts (bike pickup).',
    'payment.confirmation.email.error': 'We could not send the confirmation email. If you do not receive it, please contact us.',
    'payment.confirmation.next.steps.title': 'Next steps',
    'payment.confirmation.next.steps.email': 'You will receive a confirmation email shortly',
    'payment.confirmation.next.steps.dni': 'Present your ID document at bike pickup',
    'payment.confirmation.next.steps.arrive': 'Arrive 10 minutes before your pickup time',
    'payment.confirmation.next.steps.contact': 'Contact us if you have any questions',
    'payment.confirmation.goHome': 'Go to home',
    'payment.confirmation.thank.you': 'Thank you for trusting us!',
    'payment.confirmation.enjoy': 'We are waiting for you to enjoy a unique experience',
    'booking.dates.label': 'Booking dates',
    'booking.dates.until': 'until',
    
    // Delivery Options
    'delivery.title': 'Delivery/Pickup Options',
    'delivery.subtitle': 'Choose how you prefer to receive your bike',
    'delivery.pickup.title': 'Store pickup',
    'delivery.pickup.description': 'Pick up your bike directly at our store',
    'delivery.pickup.benefit.no.cost': 'No additional cost',
    'delivery.pickup.benefit.immediate': 'Available immediately',
    'delivery.pickup.benefit.assistance': 'Personalized assistance',
    'delivery.pickup.benefit.review': 'Technical review included',
    'delivery.delivery.title': 'Home delivery',
    'delivery.delivery.title.from.price': 'Home delivery from 40€',
    'delivery.delivery.description': 'We bring the bike to your home or hotel',
    'delivery.delivery.benefit.location': 'Delivery to your location',
    'delivery.delivery.benefit.flexible': 'Flexible schedule',
    'delivery.delivery.benefit.assembly': 'Assembly included',
    'delivery.delivery.benefit.pickup': 'Pickup at the end',
    'delivery.delivery.benefit.fixed.cost': 'Fixed cost of 40€ for reservations ≤ 3 days',
    'delivery.cost.calculated': 'Delivery cost calculated',
    'delivery.cost.based.on.distance': 'Based on distance from our store',
    'delivery.info.title': 'Delivery service information',
    'delivery.info.base.cost': 'The service has a cost from 40 €, which includes up to 15 km from our location in Cala Millor.',
    'delivery.info.mallorca.only': 'Deliveries and pickups are only made within the island of Mallorca.',
    'delivery.info.supplement': 'If the delivery address is more than 15 km away, a supplement of 2.50 € per additional kilometer will be applied.',
    'delivery.info.distance.calculation': 'Kilometers are calculated only according to the distance of one trip (from our location to your location).',
    'delivery.info.example': 'Example:',
    'delivery.info.example.text': 'If your hotel is 20 km away, 5 extra km apply → 5 × 2.50 € = 12.50 € supplement.',
    'delivery.info.transparent': 'This ensures a transparent, fair service adapted to the real distance of your location.',
    'delivery.address.title': 'Delivery address',
    'delivery.address.full': 'Full address',
    'delivery.address.placeholder': 'The address will be automatically completed from the map, or you can write it manually here...',
    'delivery.address.help': 'You can add additional details such as floor number, access code, or special instructions',
    'delivery.map.title': 'Location on the map',
    'delivery.map.search.placeholder': 'Search your address or click on the map...',
    'delivery.map.search': 'Search',
    'delivery.map.searching': 'Searching...',
    'delivery.map.location.valid': '✔️ Valid location within Mallorca',
    'delivery.map.location.invalid': '❌ The location is NOT within Mallorca.',
    'delivery.map.address.not.found': '❌ Address not found.',
    'delivery.map.address.error': '❌ Error searching for address. Please try again.',
    'delivery.map.distance.to.store': 'Distance to store:',
    'delivery.map.address.label': 'Address:',
    'delivery.map.base.cost': 'Base cost:',
    'delivery.map.base.cost.includes': '40.00 € (includes up to {km} km)',
    'delivery.map.supplement': 'Supplement for {km} additional km:',
    'delivery.map.total.delivery': 'Total delivery:',
    'delivery.map.address.selected': 'Address selected',
    'delivery.map.address.correct': 'If the address shown is not correct, you can click directly on the map to select the exact location.',
    'delivery.map.help': 'You can search for an address or click directly on the map to select your location',
    'delivery.map.our.store': 'Our store',
    'delivery.map.store.location': 'Cala Millor, Mallorca',
    'delivery.map.your.location': 'Your location',
    'delivery.map.location.selected': 'Location selected',
    'delivery.map.distance': 'Distance',
    
    // Common
    // Customer Info
    'customer.title': 'Customer Information',
    'customer.subtitle': 'Complete your personal information to continue with the reservation',
    'customer.name.label': 'Full name',
    'customer.name.placeholder': 'Enter your full name',
    'customer.name.required': 'Name is required',
    'customer.name.min.length': 'Name must be at least 2 characters',
    'customer.name.max.length': 'Name cannot exceed 100 characters',
    'customer.name.invalid': 'Only letters and spaces allowed (no numbers or special characters)',
    'customer.email.label': 'Email',
    'customer.email.placeholder': 'your@email.com',
    'customer.email.required': 'Email is required',
    'customer.email.invalid': 'Please enter a valid email address',
    'customer.email.max.length': 'Email cannot exceed 254 characters',
    'customer.phone.label': 'Phone',
    'customer.phone.placeholder': '123456789',
    'customer.phone.required': 'Phone is required',
    'customer.phone.invalid': 'Invalid phone (9 digits)',
    'customer.phone.prefix.label': 'Prefix',
    'customer.phone.prefix.hint': 'Up to 4 digits, with or without +',
    'customer.phone.prefix.placeholder': '+34',
    'customer.phone.prefix.required': 'Phone prefix is required',
    'customer.phone.prefix.invalid': 'Invalid prefix (up to 4 digits, with or without +)',
    'customer.dni.label': 'ID Document',
    'customer.dni.placeholder': 'DNI, NIE or passport',
    'customer.dni.required': 'ID document is required',
    'customer.dni.invalid': 'Invalid format (DNI: 8 digits + letter, NIE: X/Y/Z + 7 digits + letter, passport: alphanumeric 5-20 characters)',
    'customer.address.label': 'Address (billing)',
    'customer.address.placeholder': 'Street, number, postcode, city',
    'customer.address.required': 'Address is required for reservations of 3000 € or more',
    'customer.info.title': 'Important information',
    'customer.info.protected': 'Your data is protected and only used for the reservation',
    'customer.info.dni.required': 'We will need your ID document for bike pickup',
    'customer.info.email.confirmation': 'We will send you confirmation by email',
    'customer.info.contact': 'You can contact us by phone if you have questions',
    'customer.processing': 'Processing...',
    'customer.clear.temp.booking': 'Clear temporary booking',
    'customer.reload.page': 'Reload page',
    'customer.error.update.temp': 'Error updating temporary booking',
    'customer.error.create.temp': 'Error creating temporary booking',
    'customer.error.handle.temp': 'Error handling temporary booking',
    'customer.error.no.vehicles': 'No vehicles selected',
    'customer.error.no.dates': 'No dates selected',
    'customer.error.vehicles.unavailable.help': 'Please select other vehicles or contact support.',

    // Inseam (optional per model)
    'inseam.title': 'Inseam length (optional)',
    'inseam.subtitle': 'Some models allow you to enter this measurement for a better fit.',
    'inseam.label': 'Inseam (cm)',
    'inseam.placeholder': 'e.g. 82',
    'inseam.error.invalid': 'Invalid inseam value. It must be between 30 and 120 cm.',
    'inseam.step2.hint': 'Some selected bikes allow you to enter inseam length in step 5 (Customer).',
    'inseam.help.aria': 'What is inseam length?',
    'inseam.help.caption': 'Measure from your crotch to the floor (in cm), wearing similar shoes to those you will ride with.',
    
    // Common
    'common.continue': 'Continue',
    'common.back': 'Back',
    'common.loading': 'Loading...',
    'common.error': 'Error',
    'common.success': 'Success',
    'common.warning': 'Warning',
    'common.info': 'Information',
    'common.connection.error': 'Connection error.',
    
    // Language Selector
    'language.selector': 'Language',
    'language.spanish': 'Español',
    'language.english': 'English',
    'language.german': 'Deutsch',
    
    // Payment
    'payment.summary': 'Reservation Summary',
    'payment.bike': 'Bike',
    'payment.bikes': 'Bikes',
    'payment.accessories': 'Accessories',
    'payment.duration': 'Duration',
    'payment.days': 'days',
    'payment.price': 'Price',
    'payment.total': 'Total',
    'payment.info.description': 'Enter your credit or debit card details to complete the reservation.',
    'payment.test.title': 'Test Data',
    'payment.test.card': 'Card',
    'payment.test.expiry': 'Expiry',
    'payment.test.cvv': 'CVV',
    'payment.card.number': 'Card Number',
    'payment.card.expiry': 'Expiry Date',
    'payment.card.cvv': 'CVV',
    'payment.loading': 'Loading payment information...',
    'payment.error.title': 'Payment Error',
    'payment.error.retry': 'Retry',
    'payment.success.title': 'Payment Successful!',
    'payment.success.message': 'Your reservation has been confirmed and payment processed successfully.',
    'payment.success.booking': 'Booking Number',
    'payment.vat.included': 'VAT included',

    // Footer
    'footer.title.contact': 'Contact',
    'footer.title.company': 'Company',
    'footer.title.quickLinks': 'Quick links',
    'footer.title.about': 'About the store',
    'footer.title.schedule': 'Opening hours',
    'footer.contact.phone1': '+34 971 58 58 38',
    'footer.contact.phone2': '+34 622 79 97 96',
    'footer.contact.email': 'info@monkeyjetski.com',
    'footer.contact.address': 'Carrer Arenal, 6, 07560 Cala Millor, Illes Balears',
    'footer.company.bikes': 'Bikes',
    'footer.company.jetski': 'Jetski tours',
    'footer.company.buggy': 'Buggy tours',
    'footer.company.parasailing': 'Parasailing',
    'footer.company.workshop': 'Bike workshop',
    'footer.quick.rental': 'Bike rental',
    'footer.quick.tours': 'Bike tours',
    'footer.quick.hotels': 'Hotel delivery',
    'footer.quick.extras': 'Extras and accessories',
    'footer.quick.routes': 'Bike routes',
    'footer.about.contact': 'Contact',
    'footer.about.us': 'About us',
    'footer.about.gallery': 'Gallery',
    'footer.about.legal': 'Legal notice',
    'footer.about.cookies': 'Cookies',
    'footer.schedule.weekdays': 'Mon - Fri',
    'footer.schedule.saturday': 'Saturday',
    'footer.schedule.sunday': 'Sunday',
    'footer.schedule.hours': '09:00 - 22:00',
    'footer.copyright': 'Copyright © {year} All Right Reserved MonkeyOnTours',
    'footer.social.strava': 'Strava',
    'footer.social.instagram': 'Instagram',
    'footer.social.facebook': 'Facebook',
    'footer.social.youtube': 'YouTube',

    // Maintenance
    'maintenance.message': 'We are currently under maintenance, we will be back soon.',
    'maintenance.contact.title': 'You can contact us at:',

    'support.api.banner.message':
      'We are having a technical issue with our servers. If it continues, book by phone or message us:',
    'support.api.banner.dismiss': 'Dismiss',
  },

  de: {
    // Header
    'booking.title': 'Fahrradverleih Buchung',
    'booking.subtitle': 'Vervollständige die Schritte für deine Reservierung',
    'header.top.phoneMessage': 'Mehr als ein Tag? Reservieren Sie telefonisch',
    'header.top.phone': '+34 622 79 97 96',
    'header.menu.home': 'Startseite',
    'header.menu.rental': 'Verleih',
    'header.menu.tours': 'Touren',
    'header.menu.delivery': 'Hotel-Lieferung',
    'header.menu.accessories': 'Zubehör',
    'header.menu.contact': 'Kontakt',
    'header.aria.menu': 'Hauptmenü',
    'header.aria.openMenu': 'Menü öffnen',
    'header.aria.closeMenu': 'Menü schließen',
    'header.lang.es': 'Español',
    'header.lang.en': 'English',
    'header.lang.de': 'Deutsch',
    
    // Stepper
    'stepper.step1': 'Daten',
    'stepper.step2': 'Fahrräder',
    'stepper.step3': 'Zubehör',
    'stepper.step4': 'Lieferung',
    'stepper.step5': 'Kunde',
    'stepper.step6': 'Zahlung',
    'stepper.back': 'Zurück',
    'stepper.step': 'Schritt',
    'stepper.of': 'von',
    
    // Date Selection
    'date.title': 'Wähle deine Reservierungsdaten',
    'date.start.label': 'Startdatum und -zeit',
    'date.end.label': 'Enddatum und -zeit',
    'date.start.help': 'Wähle ein Datum und eine Zeit zwischen 9:00 und 21:00 Uhr',
    'date.end.help': 'Mindestens 1 Tag, keine maximale Begrenzung',
    'date.info.title': 'Wichtige Informationen',
    'date.info.min': '• Die Mindestdauer der Reservierung beträgt 1 vollständigen Tag (24 Stunden)',
    'date.info.max': '• Keine maximale Dauerbegrenzung',
    'date.info.hours': '• Die Servicezeiten sind von 9:00 bis 21:00 Uhr',
    'date.info.advance': '• Reservierungen können mit mindestens 24 Stunden Vorlaufzeit gemacht werden',
    'date.duration': 'Reservierungsdauer:',
    'date.total': 'Gesamt:',
    'date.hours': 'Stunden',
    'date.day': 'Tag',
    'date.days': 'Tage',
    'date.hour': 'Stunde',
    'date.and': 'und',
    'date.over.limit': 'Erweiterte Reservierung',
    'date.over.contact': 'Für längere Reservierungen kontaktieren Sie',
    'date.error.min': 'Die Mindestdauer der Reservierung muss 1 vollständigen Tag (24 Stunden) betragen',
    'date.error.max': 'Keine maximale Dauerbegrenzung für Reservierungen',
    'date.error.start.time': 'Die Startzeit muss zwischen 9:00 und 21:00 Uhr liegen',
    'date.error.end.time': 'Die Endzeit muss zwischen 9:00 und 21:00 Uhr liegen',
    'date.error.start.past': 'Das Startdatum kann nicht vor heute liegen',
    'date.error.required': 'Wähle ein Abhol- und ein Rückgabedatum',
    'date.error.min.days': 'Die Reservierung muss mindestens 1 Tag betragen',
    'date.error.closed': 'An diesem Tag haben wir geschlossen: Abholung und Rückgabe sind an Ruhetagen nicht möglich',
    'date.continue': 'Weiter',
    'date.schedule.info.title': 'Zeitplan-Informationen',
    'date.schedule.info.pickup': '• Abholzeit: 9:00 Uhr',
    'date.schedule.info.return': '• Rückgabezeit: 21:00 Uhr (9:00 PM)',
    'date.schedule.info.minimum': '• Mindestreservierung: 1 vollständiger Tag',
    'date.schedule.info.maximum': '• Keine maximale Tagesbegrenzung',
    'date.schedule.info.advance': '• Reservierungen mit mindestens 24 Stunden Vorlaufzeit',
    'date.schedule.title': 'Zeitplan',
    'date.schedule.mobile.times': 'Abholung: 9:00 Uhr • Rückgabe: 21:00 Uhr',
    'date.schedule.mobile.duration': 'Minimum: 1 Tag • Keine maximale Begrenzung',
    'date.pickup.label': 'Abholdatum',
    'date.pickup.help': 'Wähle das Abholdatum (9:00 Uhr)',
    'date.return.label': 'Rückgabedatum',
    'date.return.help': 'Wähle das Rückgabedatum (21:00 Uhr)',
    'date.duration.label': 'Reservierungsdauer:',
    'date.duration.range': 'Von {start} bis {end}',
    
    // Date Range Picker
    'daterangepicker.select.range': 'Datumsbereich auswählen',
    'daterangepicker.clear.dates': 'Daten löschen',
    'daterangepicker.select.dates': 'Daten auswählen',
    'daterangepicker.close': 'Schließen',
    'daterangepicker.closed.legend': 'Ruhetage (keine Abholung oder Rückgabe)',
    'daterangepicker.start.date': 'Startdatum',
    'daterangepicker.end.date': 'Enddatum',
    'daterangepicker.duration': 'Dauer:',
    'daterangepicker.confirm': 'Daten bestätigen',

    // Bike Catalog
    'bike.title': 'Fahrräder auswählen',
    'bike.filters': 'Filter',
    'bike.category': 'Kategorie',
    'bike.size': 'Größe',
    'bike.all.categories': 'Alle Kategorien',
    'bike.all.sizes': 'Alle Größen',
    'bike.base.price': '€/Stunde',
    'bike.select.sizes': 'Größen auswählen:',
    'bike.available': 'verfügbar',
    'bike.loading': 'Verfügbarkeit wird geladen...',
    'bike.error': 'Fehler beim Überprüfen der Verfügbarkeit:',
    'bike.no.models': 'Keine Fahrräder verfügbar mit den ausgewählten Filtern',
    'bike.filter.all.categories': 'Alle Kategorien',
    'bike.filter.all.sizes': 'Alle Größen',
    'bike.filter.category': 'Kategorie',
    'bike.filter.category.placeholder': 'Kategorie auswählen',
    'bike.filter.size': 'Größe auswählen',
    'bike.dates.label': 'Reservierungsdaten',
    'bike.dates.required.prompt': 'Wähle einen Zeitraum, um die Verfügbarkeit zu prüfen.',
    'bike.selected.singular': 'ausgewählt',
    'bike.selected.plural': 'ausgewählt',
    'bike.mixed.seasons': 'Gemischte Saisons',
    'bike.back.to.info': 'Zurück zur Fahrradinformation',
    'bike.total.availability': 'Gesamtverfügbarkeit:',
    'bike.bikes': 'Fahrräder',
    'bike.price.from': 'Ab',
    'bike.image.none': 'Kein Bild',
    'bike.image.loading': 'Bild wird geladen…',
    'bike.image.error': 'Bild konnte nicht geladen werden',
    'bike.no.availability': 'Einige ausgewählte Fahrräder sind für diese Termine nicht mehr verfügbar und wurden aus dem Angebot genommen.',
    'bike.more': 'mehr',
    'bike.and': 'und',

    // Accessory Selection
    'accessory.title': 'Zubehör auswählen',
    'accessory.loading': 'Zubehör wird geladen...',
    'accessory.selected.bikes': 'Ausgewählte Fahrräder',
    'accessory.for.bike': 'Zubehör und Versicherungen für',
    'accessory.summary': 'Preisübersicht',
    'accessory.bikes.total': 'Fahrräder gesamt',
    'accessory.accessories.total': 'Zubehör gesamt',
    'accessory.grand.total': 'Gesamtsumme',
    'accessory.price.fixed': 'Fester Preis',
    'accessory.price.daily': 'Tagespreis',
    'accessory.price.total': 'gesamt',
    
    // Price Breakdown
    'price.title': 'Reservierungsübersicht',
    'price.select.bikes': 'Wähle Fahrräder um die Aufschlüsselung zu sehen',
    'price.selected.dates': 'Ausgewählte Daten:',
    'price.duration': 'Dauer:',
    'price.selected.bikes': 'Ausgewählte Fahrräder:',
    'price.size': 'Größe',
    'price.number': 'Nr.',
    'price.total': 'gesamt',
    'price.per.hour': 'Preis pro Stunde',
    'price.total.duration': 'Gesamtdauer',
    'price.grand.total': 'Gesamt',
    'price.vat.included': 'MwSt. inbegriffen',
    'price.base': 'Basis',
    'price.vat': 'MwSt. (21%)',
    'price.bikes': 'Fahrräder',
    'price.discount.3to5.info': 'Buchungen von 3 bis 5 Tagen: {percent}% Rabatt auf den Fahrradmietpreis (ohne Zubehör, Versicherung und Lieferung). Der angezeigte Betrag enthält diese Tarifstaffel bereits.',
    'price.discount.3to5.info.mixed': 'Buchungen von 3 bis 5 Tagen: der Rabatt auf die Fahrradmiete ist modellabhängig (siehe Details oben). Er gilt nicht für Zubehör, Versicherung oder Lieferung.',
    'price.discount.3to5.info.generic': 'Staffelpreis für 3–5 Tage auf die Fahrradmiete (bereits in der Zwischensumme enthalten). Gilt nicht für Zubehör, Versicherung oder Lieferung.',
    'price.accessories': 'Zubehör',
    'price.accessories.selected': 'Ausgewähltes Zubehör und Versicherungen:',
    'price.accessory.fixed': 'fest',
    'price.accessory.per.day': 'Tag',
    'price.delivery.home': 'Lieferung nach Hause',
    'price.warning.insurance.none': 'Sie haben keine Versicherung für diese Buchung ausgewählt.',
    'price.warning.insurance.only.one.bike': 'Die Versicherung wurde nur für ein Fahrrad ausgewählt.',
    'price.warning.insurance.partial': 'Die Versicherung wurde nur für {count} Fahrräder ausgewählt.',

    // Payment
    'payment.title': 'Sichere Zahlung',
    'payment.subtitle': 'Vervollständige deine Zahlungsinformationen, um die Reservierung abzuschließen',
    'payment.secure': '100% sichere Zahlung mit Stripe',
    'payment.card.info': 'Karteninformationen',
    'payment.processing': 'Verarbeitung...',
    'payment.pay': 'Bezahlen',
    'payment.plan.title': 'Zahlungsart',
    'payment.plan.full': 'Gesamtbetrag jetzt zahlen',
    'payment.plan.partial': 'Nur Anzahlung',
    'payment.plan.partial.note': 'Anzahlung von ca. {percent}% des Gesamtbetrags: {amount}. Den Rest klären wir später mit dir.',
    'payment.info.title': 'Zahlungsinformationen',
    'payment.summary.title': 'Reservierungsübersicht',
    'payment.summary.customer.data': 'Kundendaten',
    'payment.summary.price.breakdown': 'Preisaufschlüsselung',
    'payment.summary.duration': 'Reservierungsdauer',
    'payment.summary.bikes': 'Fahrräder',
    'payment.summary.accessories.total': 'Gesamtzubehör',
    'payment.summary.insurance.total': 'Versicherung',
    'payment.summary.delivery.total': 'Gesamtlieferung',
    'payment.summary.booking.total': 'Gesamtreservierung',
    'payment.summary.vehicles.selected': 'Ausgewählte Fahrzeuge',
    'payment.summary.size': 'Größe',
    'payment.summary.accessories.selected': 'Ausgewähltes Zubehör',
    'payment.summary.daily': 'Täglich',
    'payment.summary.fixed': 'Fest',
    'payment.summary.vehicle.accessoriesOnly': 'Zubehör',
    'payment.summary.vehicle.insuranceOnly': 'Versicherung',
    'payment.summary.vehicle.noExtras': 'Kein Zubehör oder Versicherung für dieses Fahrzeug.',
    'payment.summary.vehicle.bikeRental': 'Fahrradmiete',
    'payment.summary.vehicle.subtotalVehicle': 'Summe dieses Fahrzeugs',
    'payment.error.create': 'Fehler beim Erstellen der Zahlung',
    'payment.error.confirm': 'Fehler beim Bestätigen der Zahlung',
    'payment.error.incomplete': 'Die Zahlung konnte nicht abgeschlossen werden',
    'payment.error.cancellation.policy.required': 'Sie müssen die Buchungs- und Mietbedingungen akzeptieren, um fortzufahren',
    'payment.cancellation.policy.accept': 'Ich akzeptiere die',
    'payment.cancellation.policy.link': 'Buchungs- und Mietbedingungen',
    'payment.cancellation.policy.url': 'https://bikerentmallorca.com/de/buchungs-und-mietbedingungen/',
    'payment.confirmation.title': 'Reservierung bestätigt!',
    'payment.confirmation.step.completed': 'Schritt 6 von 6 - Abgeschlossen',
    'payment.confirmation.success.title': 'Zahlung erfolgreich!',
    'payment.confirmation.success.message': 'Deine Reservierung wurde bestätigt und korrekt verarbeitet',
    'payment.confirmation.booking.details': 'Reservierungsdetails',
    'payment.confirmation.booking.number': 'Reservierungsnummer:',
    'payment.confirmation.booking.customer': 'Kunde:',
    'payment.confirmation.booking.total.paid': 'Jetzt bezahlter Betrag:',
    'payment.confirmation.booking.total.reservation': 'Gesamtbetrag der Reservierung',
    'payment.confirmation.balance.pending': 'Ausstehender Betrag',
    'payment.confirmation.balance.pending.note': 'Diesen Betrag musst du vor Beginn der Anmietung (Abholung der Fahrräder) begleichen.',
    'payment.confirmation.email.error': 'Die Bestätigungs-E-Mail konnte nicht gesendet werden. Wenn du sie nicht erhältst, kontaktiere uns bitte.',
    'payment.confirmation.next.steps.title': 'Nächste Schritte',
    'payment.confirmation.next.steps.email': 'Du erhältst in Kürze eine Bestätigungs-E-Mail',
    'payment.confirmation.next.steps.dni': 'Präsentiere dein Ausweisdokument bei der Fahrradabholung',
    'payment.confirmation.next.steps.arrive': 'Komm 10 Minuten vor deiner Abholzeit an',
    'payment.confirmation.next.steps.contact': 'Kontaktiere uns, wenn du Fragen hast',
    'payment.confirmation.goHome': 'Zur Startseite',
    'payment.confirmation.thank.you': 'Danke für das Vertrauen!',
    'payment.confirmation.enjoy': 'Wir freuen uns, dich zu empfangen und eine einzigartige Erfahrung zu bieten',
    'booking.dates.label': 'Buchungsdaten',
    'booking.dates.until': 'bis',
    
    // Delivery Options
    'delivery.title': 'Liefer-/Abholoptionen',
    'delivery.subtitle': 'Wähle, wie du dein Fahrrad erhalten möchtest',
    'delivery.pickup.title': 'Abholung im Geschäft',
    'delivery.pickup.description': 'Hole dein Fahrrad direkt in unserem Geschäft ab',
    'delivery.pickup.benefit.no.cost': 'Keine zusätzlichen Kosten',
    'delivery.pickup.benefit.immediate': 'Sofort verfügbar',
    'delivery.pickup.benefit.assistance': 'Persönliche Betreuung',
    'delivery.pickup.benefit.review': 'Technische Überprüfung inbegriffen',
    'delivery.delivery.title': 'Lieferung nach Hause',
    'delivery.delivery.title.from.price': 'Lieferung nach Hause ab 40€',
    'delivery.delivery.description': 'Wir bringen das Fahrrad zu dir nach Hause oder ins Hotel',
    'delivery.delivery.benefit.location': 'Lieferung an deinen Standort',
    'delivery.delivery.benefit.flexible': 'Flexibler Zeitplan',
    'delivery.delivery.benefit.assembly': 'Montage inbegriffen',
    'delivery.delivery.benefit.pickup': 'Abholung am Ende',
    'delivery.delivery.benefit.fixed.cost': 'Fester Preis von 40€ für Reservierungen ≤ 3 Tage',
    'delivery.cost.calculated': 'Lieferkosten berechnet',
    'delivery.cost.based.on.distance': 'Basierend auf der Entfernung von unserem Geschäft',
    'delivery.info.title': 'Informationen zum Lieferdienst',
    'delivery.info.base.cost': 'Der Service kostet ab 40 € und umfasst bis zu 15 km von unserem Standort in Cala Millor.',
    'delivery.info.mallorca.only': 'Lieferungen und Abholungen erfolgen nur auf der Insel Mallorca.',
    'delivery.info.supplement': 'Wenn die Lieferadresse mehr als 15 km entfernt ist, wird ein Aufschlag von 2,50 € pro zusätzlichem Kilometer berechnet.',
    'delivery.info.distance.calculation': 'Die Kilometer werden nur nach der Entfernung einer Strecke berechnet (von unserem Standort zu deinem Standort).',
    'delivery.info.example': 'Beispiel:',
    'delivery.info.example.text': 'Wenn dein Hotel 20 km entfernt ist, werden 5 zusätzliche km berechnet → 5 × 2,50 € = 12,50 € Aufschlag.',
    'delivery.info.transparent': 'Dies gewährleistet einen transparenten, fairen Service, der an die tatsächliche Entfernung deines Standorts angepasst ist.',
    'delivery.address.title': 'Lieferadresse',
    'delivery.address.full': 'Vollständige Adresse',
    'delivery.address.placeholder': 'Die Adresse wird automatisch von der Karte ausgefüllt, oder du kannst sie hier manuell eingeben...',
    'delivery.address.help': 'Du kannst zusätzliche Details wie Stockwerk, Zugangscode oder besondere Anweisungen hinzufügen',
    'delivery.map.title': 'Standort auf der Karte',
    'delivery.map.search.placeholder': 'Suche deine Adresse oder klicke auf die Karte...',
    'delivery.map.search': 'Suchen',
    'delivery.map.searching': 'Suche...',
    'delivery.map.location.valid': '✔️ Gültiger Standort innerhalb von Mallorca',
    'delivery.map.location.invalid': '❌ Der Standort liegt NICHT innerhalb von Mallorca.',
    'delivery.map.address.not.found': '❌ Adresse nicht gefunden.',
    'delivery.map.address.error': '❌ Fehler beim Suchen der Adresse. Bitte versuche es erneut.',
    'delivery.map.distance.to.store': 'Entfernung zum Geschäft:',
    'delivery.map.address.label': 'Adresse:',
    'delivery.map.base.cost': 'Grundpreis:',
    'delivery.map.base.cost.includes': '40,00 € (umfasst bis zu {km} km)',
    'delivery.map.supplement': 'Aufschlag für {km} zusätzliche km:',
    'delivery.map.total.delivery': 'Gesamtlieferung:',
    'delivery.map.address.selected': 'Adresse ausgewählt',
    'delivery.map.address.correct': 'Wenn die angezeigte Adresse nicht korrekt ist, kannst du direkt auf die Karte klicken, um den genauen Standort auszuwählen.',
    'delivery.map.help': 'Du kannst nach einer Adresse suchen oder direkt auf die Karte klicken, um deinen Standort auszuwählen',
    'delivery.map.our.store': 'Unser Geschäft',
    'delivery.map.store.location': 'Cala Millor, Mallorca',
    'delivery.map.your.location': 'Dein Standort',
    'delivery.map.location.selected': 'Standort ausgewählt',
    'delivery.map.distance': 'Entfernung',
    
    // Common
    // Customer Info
    'customer.title': 'Kundendaten',
    'customer.subtitle': 'Vervollständige deine persönlichen Daten, um mit der Reservierung fortzufahren',
    'customer.name.label': 'Vollständiger Name',
    'customer.name.placeholder': 'Gib deinen vollständigen Namen ein',
    'customer.name.required': 'Name ist erforderlich',
    'customer.name.min.length': 'Name muss mindestens 2 Zeichen lang sein',
    'customer.name.max.length': 'Der Name darf maximal 100 Zeichen haben',
    'customer.name.invalid': 'Nur Buchstaben und Leerzeichen (keine Zahlen oder Sonderzeichen)',
    'customer.email.label': 'E-Mail',
    'customer.email.placeholder': 'deine@email.com',
    'customer.email.required': 'E-Mail ist erforderlich',
    'customer.email.invalid': 'Bitte gib eine gültige E-Mail-Adresse ein',
    'customer.email.max.length': 'E-Mail darf maximal 254 Zeichen haben',
    'customer.phone.label': 'Telefon',
    'customer.phone.placeholder': '123456789',
    'customer.phone.required': 'Telefon ist erforderlich',
    'customer.phone.invalid': 'Ungültiges Telefon (9 Ziffern)',
    'customer.phone.prefix.label': 'Vorwahl',
    'customer.phone.prefix.hint': 'Bis zu 4 Ziffern, mit oder ohne +',
    'customer.phone.prefix.placeholder': '+34',
    'customer.phone.prefix.required': 'Telefonvorwahl ist erforderlich',
    'customer.phone.prefix.invalid': 'Ungültige Vorwahl (bis zu 4 Ziffern, mit oder ohne +)',
    'customer.dni.label': 'Ausweisdokument',
    'customer.dni.placeholder': 'DNI, NIE oder Reisepass',
    'customer.dni.required': 'Ausweisdokument ist erforderlich',
    'customer.dni.invalid': 'Ungültiges Format (DNI: 8 Ziffern + Buchstabe, NIE: X/Y/Z + 7 Ziffern + Buchstabe, Reisepass: alphanumerisch 5-20 Zeichen)',
    'customer.address.label': 'Adresse (Rechnung)',
    'customer.address.placeholder': 'Straße, Hausnummer, PLZ, Ort',
    'customer.address.required': 'Die Adresse ist bei Buchungen ab 3000 € erforderlich',
    'customer.info.title': 'Wichtige Informationen',
    'customer.info.protected': 'Deine Daten sind geschützt und werden nur für die Reservierung verwendet',
    'customer.info.dni.required': 'Wir benötigen dein Ausweisdokument für die Abholung des Fahrrads',
    'customer.info.email.confirmation': 'Wir senden dir eine Bestätigung per E-Mail',
    'customer.info.contact': 'Du kannst uns telefonisch kontaktieren, wenn du Fragen hast',
    'customer.processing': 'Verarbeitung...',
    'customer.clear.temp.booking': 'Temporäre Reservierung löschen',
    'customer.reload.page': 'Seite neu laden',
    'customer.error.update.temp': 'Fehler beim Aktualisieren der temporären Reservierung',
    'customer.error.create.temp': 'Fehler beim Erstellen der temporären Reservierung',
    'customer.error.handle.temp': 'Fehler beim Bearbeiten der temporären Reservierung',
    'customer.error.no.vehicles': 'Keine Fahrräder ausgewählt',
    'customer.error.no.dates': 'Keine Daten ausgewählt',
    'customer.error.vehicles.unavailable.help': 'Bitte wähle andere Fahrräder aus oder kontaktiere den Support.',

    // Inseam (optional per model)
    'inseam.title': 'Schrittlänge (optional)',
    'inseam.subtitle': 'Bei einigen Modellen kannst du diese Angabe machen, um das Fahrrad besser anzupassen.',
    'inseam.label': 'Schrittlänge (cm)',
    'inseam.placeholder': 'z.B. 82',
    'inseam.error.invalid': 'Ungültige Schrittlänge. Sie muss zwischen 30 und 120 cm liegen.',
    'inseam.step2.hint': 'Bei einigen ausgewählten Fahrrädern kannst du die Schrittlänge in Schritt 5 (Kunde) angeben.',
    'inseam.help.aria': 'Was ist die Schrittlänge?',
    'inseam.help.caption': 'Miss vom Schritt bis zum Boden (in cm), mit ähnlichen Schuhen wie beim Fahren.',
    
    // Common
    'common.continue': 'Weiter',
    'common.back': 'Zurück',
    'common.loading': 'Lädt...',
    'common.error': 'Fehler',
    'common.success': 'Erfolg',
    'common.warning': 'Warnung',
    'common.info': 'Information',
    'common.connection.error': 'Connection error.',
    
    // Language Selector
    'language.selector': 'Sprache',
    'language.spanish': 'Español',
    'language.english': 'English',
    'language.german': 'Deutsch',
    
    // Payment
    'payment.summary': 'Reservierungsübersicht',
    'payment.bike': 'Fahrrad',
    'payment.bikes': 'Fahrräder',
    'payment.accessories': 'Zubehör',
    'payment.duration': 'Dauer',  
    'payment.days': 'Tage',
    'payment.price': 'Preis',
    'payment.total': 'Gesamt',
    'payment.info.description': 'Gib deine Kredit- oder Debitkartendaten ein, um die Reservierung abzuschließen.',
    'payment.test.title': 'Testdaten',
    'payment.test.card': 'Karte',
    'payment.test.expiry': 'Ablauf',
    'payment.test.cvv': 'CVV',
    'payment.card.number': 'Kartennummer',
    'payment.card.expiry': 'Ablaufdatum',
    'payment.card.cvv': 'CVV',
    'payment.loading': 'Zahlungsinformationen werden geladen...',
    'payment.error.title': 'Zahlungsfehler',
    'payment.error.retry': 'Wiederholen',
    'payment.success.title': 'Zahlung erfolgreich!',
    'payment.success.message': 'Deine Reservierung wurde bestätigt und die Zahlung erfolgreich verarbeitet.',
    'payment.success.booking': 'Buchungsnummer',
    'payment.vat.included': 'MwSt. inbegriffen',

    // Footer
    'footer.title.contact': 'Kontakt',
    'footer.title.company': 'Unternehmen',
    'footer.title.quickLinks': 'Schnelllinks',
    'footer.title.about': 'Über den Shop',
    'footer.title.schedule': 'Öffnungszeiten',
    'footer.contact.phone1': '+34 971 58 58 38',
    'footer.contact.phone2': '+34 622 79 97 96',
    'footer.contact.email': 'info@monkeyjetski.com',
    'footer.contact.address': 'Carrer Arenal, 6, 07560 Cala Millor, Illes Balears',
    'footer.company.bikes': 'Fahrräder',
    'footer.company.jetski': 'Jetski-Touren',
    'footer.company.buggy': 'Buggy-Touren',
    'footer.company.parasailing': 'Parasailing',
    'footer.company.workshop': 'Fahrradwerkstatt',
    'footer.quick.rental': 'Fahrradverleih',
    'footer.quick.tours': 'Fahrradtouren',
    'footer.quick.hotels': 'Hotel-Lieferung',
    'footer.quick.extras': 'Extras und Zubehör',
    'footer.quick.routes': 'Fahrradrouten',
    'footer.about.contact': 'Kontakt',
    'footer.about.us': 'Über uns',
    'footer.about.gallery': 'Galerie',
    'footer.about.legal': 'Impressum',
    'footer.about.cookies': 'Cookies',
    'footer.schedule.weekdays': 'Mo - Fr',
    'footer.schedule.saturday': 'Samstag',
    'footer.schedule.sunday': 'Sonntag',
    'footer.schedule.hours': '09:00 - 22:00',
    'footer.copyright': 'Copyright © {year} All Right Reserved MonkeyOnTours',
    'footer.social.strava': 'Strava',
    'footer.social.instagram': 'Instagram',
    'footer.social.facebook': 'Facebook',
    'footer.social.youtube': 'YouTube',

    // Maintenance
    'maintenance.message': 'Wir befinden uns derzeit in Wartung, wir sind bald wieder da.',
    'maintenance.contact.title': 'Sie können uns erreichen unter:',

    'support.api.banner.message':
      'Es liegt ein technisches Problem mit unseren Servern vor. Bei anhaltenden Problemen buchen Sie telefonisch oder schreiben Sie uns:',
    'support.api.banner.dismiss': 'Schließen',
  }
};

export const getTranslation = (key, language = 'es') => {
  return translations[language]?.[key] || translations['es'][key] || key;
}; 